import { Component, OnInit } from '@angular/core';


import {homeComponentService} from '../services/app.services'
import{IContact,IAboutUs} from '../model/app.model'

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html'
    
})

export class AboutComponent implements OnInit {
    
    
    about:IAboutUs
    
    

    constructor(private homeService: homeComponentService) {

    
  }

    ngOnInit() {

        
        

        this.homeService.getAboutUs().subscribe(about => {
        this.about = about;


        })


  }
    
}



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/home/about.component.ts